// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"949":"8a283465","970":"b1079943","994":"0194050b"}[chunkId] + ".js";
};